import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormTextField from '../../../FormFields/FormTextField';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormTitle from '../../../FormFields/FormTitle';
import { CLINICAL } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';
import { CLINICAL_EQUIPMENT_OPTIONS } from '../../../optionEnums';

EquipmentForm.propTypes = {
  permissions: PropTypes.object,
};

export default function EquipmentForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);
  const showForm = [
    CLINICAL.EQUIPMENT_OPTIONS,
    CLINICAL.GLUCOMETER_MANUFACTURER,
    CLINICAL.GLUCOMETER_TPY,
    CLINICAL.COVID_TEST_MANUFACTURER,
    CLINICAL.COVID_TEST_TPY,
    CLINICAL.URINE_TEST_MANUFACTURER,
    CLINICAL.URINE_TEST_TPY,
    CLINICAL.FECAL_TEST_MANUFACTURER,
    CLINICAL.FECAL_TEST_TPY,
  ].some(({ id }) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Equipment
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL.EQUIPMENT_OPTIONS.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Equipment' }} />
                <FormButtonOptions
                  fieldName={CLINICAL.EQUIPMENT_OPTIONS.fieldName}
                  isMultiSelect
                  fieldAttributes={{
                    isEditable: permissions[CLINICAL.EQUIPMENT_OPTIONS.id],
                    options: CLINICAL_EQUIPMENT_OPTIONS,
                  }}
                />
              </FieldContainer>
            </Grid>
          )}

          <Grid item container xs={12} spacing={1.5}>
            {CLINICAL.GLUCOMETER_MANUFACTURER.id in permissions && (
              <Grid item xs={12} md={4}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Glucometer manufacturer' }} />
                  <FormTextField
                    fieldName={CLINICAL.GLUCOMETER_MANUFACTURER.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.GLUCOMETER_MANUFACTURER.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
            {CLINICAL.GLUCOMETER_TPY.id in permissions && (
              <Grid item xs={12} md={2}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Volume of tests per year' }} />
                  <FormNumberField
                    fieldName={CLINICAL.GLUCOMETER_TPY.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.GLUCOMETER_TPY.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
          </Grid>

          <Grid item container xs={12} spacing={1.5}>
            {CLINICAL.COVID_TEST_MANUFACTURER.id in permissions && (
              <Grid item xs={12} md={4}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Covid test manufacturer' }} />
                  <FormTextField
                    fieldName={CLINICAL.COVID_TEST_MANUFACTURER.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.COVID_TEST_MANUFACTURER.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
            {CLINICAL.COVID_TEST_TPY.id in permissions && (
              <Grid item xs={12} md={2}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Volume of tests per year' }} />
                  <FormNumberField
                    fieldName={CLINICAL.COVID_TEST_TPY.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.COVID_TEST_TPY.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
          </Grid>

          <Grid item container xs={12} spacing={1.5}>
            {CLINICAL.URINE_TEST_MANUFACTURER.id in permissions && (
              <Grid item xs={12} md={4}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Urine dip stick test manufacturer' }} />
                  <FormTextField
                    fieldName={CLINICAL.URINE_TEST_MANUFACTURER.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.URINE_TEST_MANUFACTURER.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
            {CLINICAL.URINE_TEST_TPY.id in permissions && (
              <Grid item xs={12} md={2}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Volume of tests per year' }} />
                  <FormNumberField
                    fieldName={CLINICAL.URINE_TEST_TPY.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.URINE_TEST_TPY.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
          </Grid>

          <Grid item container xs={12} spacing={1.5}>
            {CLINICAL.FECAL_TEST_MANUFACTURER.id in permissions && (
              <Grid item xs={12} md={4}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Fecal occult blood test manufacturer' }} />
                  <FormTextField
                    fieldName={CLINICAL.FECAL_TEST_MANUFACTURER.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.FECAL_TEST_MANUFACTURER.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
            {CLINICAL.FECAL_TEST_TPY.id in permissions && (
              <Grid item xs={12} md={2}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Volume of tests per year' }} />
                  <FormNumberField
                    fieldName={CLINICAL.FECAL_TEST_TPY.fieldName}
                    fieldAttributes={{ isEditable: permissions[CLINICAL.FECAL_TEST_TPY.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Card>
    )
  );
}
